import React from "react";
import Avatar from "@mui/material/Avatar";

interface IUserAvatarProps {
    username: string;
    avatar?: { public_url?: string; fid?: string } | null;
    size: string;
    disablePointer?: boolean; // New optional prop
    displayProfilePicture?: boolean;
}

const UserAvatar: React.FC<IUserAvatarProps> = ({
    username,
    avatar,
    size,
    disablePointer,
    displayProfilePicture = true,
}) => {
    if (!displayProfilePicture) {
        return null;
    }

    const checkProperties = (): boolean =>
        !!avatar &&
        typeof avatar === "object" &&
        avatar.hasOwnProperty("public_url") &&
        avatar.hasOwnProperty("fid");

    const getInitials = (author: string) => {
        if (!author) return;
        return author.charAt(0).toUpperCase() + author.charAt(1).toUpperCase();
    };

    const hasImage = checkProperties();
    const sizeSx =
        size === "small"
            ? { width: 32, height: 32, fontSize: "1rem" }
            : size === "large"
            ? { width: 120, height: 120, fontSize: "2.25rem" }
            : { width: 40, height: 40 };
    const cursorSx = { cursor: disablePointer ? "default" : "pointer" };

    return hasImage ? (
        <Avatar
            alt={username}
            src={`${(avatar as any)["public_url"]}/${(avatar as any)["fid"]}`}
            sx={{ ...sizeSx, ...cursorSx }}
        />
    ) : (
        <Avatar alt={username} sx={{ ...sizeSx, ...cursorSx }}>
            {getInitials(username)}
        </Avatar>
    );
};

export default React.memo(UserAvatar);
